import * as AT from './_types'
import { setCreatingConvoState } from './conversations-messages'

export const chooseCurrentConversation = conversationId => dispatch => {
  dispatch(setCreatingConvoState(false))
  return dispatch({
    type: AT.CURR_CHOOSE_CONVERSATION,
    conversationId,
  })
}

export const resetCurrentConversation = () => ({
  type: AT.CURR_RESET_CONVERSATION,
})

export const setCurrConvoMsgType = msgType => dispatch =>
  dispatch({
    type: AT.CURR_CONVERSATION_IS_EMAIL,
    isEmail: msgType === 'email',
  })

export const isCurrConversationEmail = () => (dispatch, getState) => {
  const state = getState()

  const { isBlastMsg, id } = state.current.conversation

  const msgType = isBlastMsg
    ? state.messageDrafts.groupMessages[id].messageType // how the hell does this work?
    : state.conversations.byId[id].messages_type

  dispatch(setCurrConvoMsgType(msgType))
}

export const updateCurrConvoHasBody = hasBodyText => dispatch => {
  dispatch({
    type: AT.CURR_CONVERSATION_HAS_BODY,
    hasBodyText,
  })
}



// WEBPACK FOOTER //
// ./src/state/actions/current.js